/* eslint-disable @typescript-eslint/no-explicit-any */
import SntSortAZ from "@icons/SntSortAZ";
import SntSortZA from "@icons/SntSortZA";

interface SortIconProps {
  column: any;
  toggleSortBy: (columnKey: string, desc: boolean) => void;
  showHoverState?: boolean;
}

export const SortIcon = ({
  column,
  toggleSortBy,
  showHoverState = true,
}: SortIconProps) => {
  if (column.disableSortBy) return null;

  const handleClick = () => {
    let desc = false;
    if (column.isSorted) {
      desc = !column.isSortedDesc;
    }
    toggleSortBy(column.columnKey, desc);
  };

  return (
    <div
      className="ms-2"
      {...column.getSortByToggleProps({
        title: column.description,
      })}
      onClick={handleClick}
    >
      {column.isSorted ? (
        column.isSortedDesc ? (
          <span className="sortIcon">
            <SntSortZA />
          </span>
        ) : (
          <span className="sortIcon">
            <SntSortAZ />
          </span>
        )
      ) : (
        <span className={showHoverState ? "sortIconHover" : "sortIcon"}>
          <SntSortAZ />
        </span>
      )}
    </div>
  );
};
